import { FeatureFlagState } from '/types';

/**
 * A react hook that returns a list of experiments codes (look like CWA-1234)
 * or `null` while loading.
 */
const useExperiments = (): null | string[] => {
  const experiments = {
    // 'CWA-XXXX': useFeatureFlag('cwa_xxxx_usage_example'),
  };
  if (Object.values(experiments).some((x) => x == FeatureFlagState.LOADING)) {
    return null;
  }
  return Object.entries(experiments)
    .filter(([, val]) => val == FeatureFlagState.TRUE)
    .map(([key]) => key);
};

export default useExperiments;
